import { useEffect, useRef, useState } from 'react';
import { startHandoffReceiver, type HandoffState, type HandoffWindow } from './runeHandoff';

/**
 * The rune handoff of this page load (lib/runeHandoff.ts). `active` = the link carries
 * handoff=1 and a template (route.ts). Listens while active; once a payload has arrived it
 * is kept in React state only — in memory, until the tab reloads or closes — so it survives
 * the in-page sign-in with an access key. Nothing is written to localStorage or sessionStorage.
 */
export function useRuneHandoff(active: boolean, expectedRune?: string): HandoffState | null {
  const [state, setState] = useState<HandoffState | null>(null);
  const received = useRef(false);

  useEffect(() => {
    if (!active || received.current) return;
    // StrictMode runs this twice in dev: the first listener is removed before the rune's
    // answer can arrive, the second takes it; the rune's second answer is then ignored.
    return startHandoffReceiver(window as unknown as HandoffWindow, {
      expectedRune,
      onState: (s) => {
        if (s.status === 'received') received.current = true;
        setState(s);
      },
    });
  }, [active, expectedRune]);

  return state;
}
